/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as h from "react";
import a from "prop-types";
import { PagerNumericButtons as ie } from "./PagerNumericButtons.mjs";
import { PagerInput as re } from "./PagerInput.mjs";
import { PagerPageSizes as oe } from "./PagerPageSizes.mjs";
import { Button as ne } from "@progress/kendo-react-buttons";
import { pagerFirstPage as b, messages as l, pagerPreviousPage as k, pagerNextPage as S, pagerLastPage as K, pagerInfo as E, pagerAriaKeyshortcuts as z, pagerPage as w, pagerOf as C, pagerTotalPages as R } from "../messages/index.mjs";
import { provideLocalizationService as ge, provideIntlService as le, registerForIntl as he, registerForLocalization as pe } from "@progress/kendo-react-intl";
import { Keys as n, focusFirstFocusableChild as ue, enableNavigatableContainer as ce, disableNavigatableContainer as me, keepFocusInContainer as de, TABBABLE_ELEMENTS as fe, validatePackage as Pe, classNames as V, kendoThemeMaps as Me } from "@progress/kendo-react-common";
import { caretAltToRightIcon as U, caretAltToLeftIcon as j, caretAltRightIcon as G, caretAltLeftIcon as H } from "@progress/kendo-svg-icons";
import { packageMetadata as ve } from "../package-metadata.mjs";
const J = 600, ye = 768, M = class M extends h.Component {
  constructor(p) {
    super(p), this._element = null, this.onPageChange = (t, e) => {
      const i = {
        target: this,
        syntheticEvent: e.syntheticEvent,
        nativeEvent: e.nativeEvent,
        targetEvent: e,
        ...t
      };
      this.props.onPageChange && this.props.onPageChange.call(void 0, i);
    }, this.changePage = (t, e) => {
      this.props.onPageChange && t > 0 && t <= this.totalPages && this.props.onPageChange({
        target: this,
        skip: (t - 1) * this.props.take,
        take: this.props.take,
        syntheticEvent: e,
        nativeEvent: e.nativeEvent,
        targetEvent: e
      });
    }, this.onWindowResize = () => {
      const t = this.element;
      if (!t || !this.props.responsive)
        return;
      const e = t.offsetWidth;
      e < J ? this.setState({ showPagerSizes: !1 }) : e >= J && e < ye ? this.setState({ showPagerInfo: !1, showPagerSizes: !0 }) : this.setState({ showPagerInfo: !0, showPagerSizes: !0 });
    }, this.onKeyDown = (t) => {
      const e = this.element, i = t.keyCode;
      !e || !this.props.navigatable || ((i === n.home || t.metaKey && i === n.left) && this.changePage(1, t), (i === n.end || t.metaKey && i === n.right) && this.changePage(this.totalPages, t), document.activeElement === e ? (i === n.enter && (ue(e), ce(e)), (i === n.left || i === n.up) && this.changePage(this.currentPage - 1, t), (i === n.right || i === n.down) && this.changePage(this.currentPage + 1, t)) : (i === n.esc && (e.focus(), me(e)), de(t, e, fe)));
    }, Pe(ve), this.state = { showPagerSizes: !0, showPagerInfo: !0, innerNavigateActive: !1 };
  }
  get isRtl() {
    return this.props.dir === "rtl";
  }
  get currentPage() {
    return Math.floor(this.props.skip / this.props.take) + 1;
  }
  /**
   * Returns the HTML element of the Pager component.
   */
  get element() {
    return this._element;
  }
  /**
   * @hidden
   */
  componentDidMount() {
    window.addEventListener("resize", this.onWindowResize), this.onWindowResize();
  }
  /**
   * @hidden
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
  }
  /**
   * @hidden
   */
  render() {
    const { showPagerSizes: p, showPagerInfo: t } = this.state, {
      skip: e,
      take: i,
      total: u,
      pageSizes: m,
      size: g,
      responsive: v,
      messagesMap: s,
      dir: Q,
      style: X,
      pageSizeValue: Y,
      previousNext: Z,
      className: ee,
      navigatable: d,
      disabled: c
    } = this.props, o = ge(this), y = le(this), r = this.currentPage, te = this.props.type === "numeric" ? /* @__PURE__ */ h.createElement(
      ie,
      {
        type: v && !p ? "dropdown" : "numbers",
        buttonCount: this.props.buttonCount || 0,
        totalPages: this.totalPages,
        currentPage: this.currentPage,
        pageChange: this.changePage,
        messagesMap: this.props.messagesMap,
        size: g,
        navigatable: d
      }
    ) : /* @__PURE__ */ h.createElement(
      re,
      {
        buttonCount: this.props.buttonCount || 0,
        totalPages: this.totalPages,
        currentPage: r,
        pageChange: this.changePage,
        messagesMap: s,
        size: g,
        navigatable: d
      }
    ), L = s ? s(b) : { messageKey: b, defaultMessage: l[b] }, I = s ? s(k) : { messageKey: k, defaultMessage: l[k] }, N = s ? s(S) : { messageKey: S, defaultMessage: l[S] }, A = s ? s(K) : { messageKey: K, defaultMessage: l[K] }, B = s ? s(E) : { messageKey: E, defaultMessage: l[E] }, T = s ? s(z) : { messageKey: z, defaultMessage: l[z] }, x = s ? s(w) : { messageKey: w, defaultMessage: l[w] }, O = s ? s(C) : { messageKey: C, defaultMessage: l[C] }, f = s ? s(R) : { messageKey: R, defaultMessage: l[R] }, se = `${o.toLanguageString(
      x.messageKey,
      x.defaultMessage
    )} ${y.format(
      o.toLanguageString(
        f.messageKey,
        f.defaultMessage
      ),
      [r]
    )} ${o.toLanguageString(
      O.messageKey,
      O.defaultMessage
    )} ${y.format(
      o.toLanguageString(
        f.messageKey,
        f.defaultMessage
      ),
      [this.totalPages]
    )}`;
    let D, F, W, _;
    Z && (D = this.renderButton(
      1,
      "k-pager-nav k-pager-first" + (r === 1 && !c ? " k-disabled" : ""),
      o.toLanguageString(L.messageKey, L.defaultMessage),
      this.isRtl ? "caret-alt-to-right" : "caret-alt-to-left",
      this.isRtl ? U : j,
      r === 1 ? !0 : void 0
    ), F = this.renderButton(
      r - 1,
      "k-pager-nav" + (r === 1 && !c ? " k-disabled" : ""),
      o.toLanguageString(I.messageKey, I.defaultMessage),
      this.isRtl ? "caret-alt-right" : "caret-alt-left",
      this.isRtl ? G : H,
      r === 1 ? !0 : void 0
    ), W = this.renderButton(
      r + 1,
      "k-pager-nav" + (r >= this.totalPages && !c ? " k-disabled" : ""),
      o.toLanguageString(N.messageKey, N.defaultMessage),
      this.isRtl ? "caret-alt-left" : "caret-alt-right",
      this.isRtl ? H : G,
      r >= this.totalPages ? !0 : void 0
    ), _ = this.renderButton(
      this.totalPages,
      "k-pager-nav k-pager-last" + (r >= this.totalPages && !c ? " k-disabled" : ""),
      o.toLanguageString(A.messageKey, A.defaultMessage),
      this.isRtl ? "caret-alt-to-left" : "caret-alt-to-right",
      this.isRtl ? j : U,
      r >= this.totalPages ? !0 : void 0
    ));
    const $ = m && /* @__PURE__ */ h.createElement(
      oe,
      {
        pageChange: this.onPageChange,
        pageSize: i,
        pageSizes: m,
        value: Y,
        messagesMap: s,
        size: g,
        navigatable: d
      }
    ), q = this.props.info && /* @__PURE__ */ h.createElement("span", { className: "k-pager-info" }, y.format(o.toLanguageString(B.messageKey, B.defaultMessage), [
      Math.min(e + 1, u),
      Math.min(e + i, u),
      u
    ]));
    return /* @__PURE__ */ h.createElement(
      "div",
      {
        className: V(
          "k-pager",
          {
            [`k-pager-${Me.sizeMap[g] || g}`]: g,
            "k-disabled": c
          },
          ee
        ),
        style: X,
        role: "application",
        "aria-roledescription": "pager",
        dir: Q,
        "aria-keyshortcuts": o.toLanguageString(T.messageKey, T.defaultMessage),
        "aria-label": se,
        ref: (ae) => this._element = ae,
        tabIndex: d ? 0 : void 0,
        onKeyDown: this.onKeyDown
      },
      /* @__PURE__ */ h.createElement("div", { className: V("k-pager-numbers-wrap") }, D, F, te, W, _),
      v ? p && $ : $,
      v ? t && q : q
    );
  }
  renderButton(p, t, e, i, u, m) {
    return /* @__PURE__ */ h.createElement(
      ne,
      {
        fillMode: "flat",
        themeColor: "base",
        size: this.props.size,
        rounded: null,
        className: t,
        icon: i,
        svgIcon: u,
        title: e,
        role: "button",
        "aria-disabled": m,
        tabIndex: this.props.navigatable ? -1 : void 0,
        onClick: (g) => {
          g.preventDefault(), this.changePage(p, g);
        }
      }
    );
  }
  get totalPages() {
    return Math.ceil((this.props.total || 0) / this.props.take);
  }
};
M.propTypes = {
  className: a.string,
  style: a.object,
  total: a.number.isRequired,
  skip: a.number.isRequired,
  take: a.number.isRequired,
  buttonCount: a.number,
  info: a.bool,
  type: a.oneOf(["numeric", "input"]),
  pageSizes: a.arrayOf(a.oneOfType([
    a.string,
    a.number
  ])),
  previousNext: a.bool,
  onPageChange: a.func,
  messagesMap: a.func,
  size: a.oneOf([null, "small", "medium", "large"]),
  dir: a.string,
  disabled: a.bool
}, M.defaultProps = {
  buttonCount: 10,
  info: !0,
  type: "numeric",
  size: "medium",
  disabled: !1
};
let P = M;
he(P);
pe(P);
export {
  P as Pager
};
